import { Component, OnInit, Input } from '@angular/core'

@Component({
    selector: 'keycom-nav-icon',
    templateUrl: './icon.component.html',
    styleUrls: ['./icon.component.scss'],
    standalone: false
})
export class IconComponent implements OnInit {
  iconClasses: string

  @Input()
  iconName: string

  @Input()
  color = '#393E46'

  @Input()
  size = 24

  ngOnInit() {
    if (this.iconName === null) {
      throw new Error('iconName is required')
    } else {
      this.iconClasses = `icon ${this.iconName}`
    }
  }
}
